<template>
  <div class="doctors">
    <div v-for="item in $$FormData.doctors" :key="item.goods_id" class="doctor-item">
      <div class="doctor-info">
        <div class="doctor-face">
          <img :src="item.goods_image" mode="widthFix" class="doctor-face-img"/>
        </div>
        <div class="doctor-profile">
          <div class="doctor-name">
            <div class="doctor-name-text">张医生</div>
            <div class="doctor-name-level">专家</div>
          </div>
          <div class="hospital-info">
            <div class="hospital-level">三甲</div>
            <div class="hospital-name">北京西京中医医院</div>
            <div class="hospital-section">肾病科</div>
          </div>
          <div class="doctor-service">
            <div class="doctor-service-label">服务</div>
            <div class="doctor-service-value">40</div>
            <div class="doctor-service-label">回复速度</div>
            <div class="doctor-service-value">1小时内</div>
          </div>
        </div>
        <div class="has-schedule">有号</div>
      </div>
      <div class="other-info">
        <div class="hospital-brand">第一执业中国中医科学院西苑医院</div>
        <div class="hospital-top">
          <div class="icon-trophy"></div>
          <div class="hospital-top-text">北京·肾炎·全国专病名医榜</div>
          <div class="icon-right"></div>
        </div>
        <div class="doctor-good">擅长：肾炎、肾病综合症、血尿、蛋白尿、肾衰、糖尿病肾病</div>
      </div>
    </div>
    <div v-if="!$$FormData.doctors || $$FormData.doctors.length === 0" class="empty-list">
      请选择医生
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoctorsPreview'
}
</script>

<style scoped lang="scss">
.doctors {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 10px;
}
.empty-list {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 50px;
  color: #999999;
}
.doctor-item {
  width: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  box-shadow: 0 4px 10px 0 rgba(175, 175, 175, 0.3);
  border-radius: 10px;
  padding: 10px 10px 8px;
}
.doctor-info {
  position: relative;
  display: flex;
  .doctor-face {
    width: 46px;
    height: 46px;
    border-radius: 500px;
    overflow: hidden;
    background-color: #d8d8d8;
    &-img {
      width: 100%;
      height: 100%;
    }
  }
  .doctor-profile {
    margin-left: 7px;
  }
  .doctor-name {
    display: flex;
    align-items: center;
    &-text {
      font-weight: 500;
      font-size: 14px;
      color: #3d3d3d;
      line-height: 19px;
    }
    &-level {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #4e7dee;
      font-size: 10px;
      margin-left: 7px;
      border: 1px solid #4e7dee;
      border-radius: 2px;
      padding: 1px 3px;
    }
  }
  .hospital-info {
    display: flex;
    align-items: center;
    margin-top: 8px;
    .hospital-level {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 10px;
      font-weight: 400;
      background-color: #fc5756;
      padding: 1px 3px;
      border-radius: 2px;
    }
    .hospital-name {
      font-weight: 400;
      font-size: 10px;
      color: #666666;
      line-height: 14px;
      margin-left: 10px;
    }
    .hospital-section {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ff6f68;
      font-size: 10px;
      font-weight: 400;
      margin-left: 10px;
      border: 1px solid #ff6f68;
      border-radius: 2px;
      padding: 1px 3px;
    }
  }
  .doctor-service {
    display: flex;
    align-items: center;
    margin-top: 3px;
    &-label {
      font-weight: 400;
      font-size: 10px;
      color: #666666;
    }
    &-value {
      font-weight: 500;
      font-size: 10px;
      color: #3d3d3d;
      margin-left: 4px;
      & + .doctor-service-label {
        margin-left: 15px;
      }
    }
  }
  .has-schedule {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    border-radius: 2px;
    background-color: #3e64e9;
    font-weight: 400;
    font-size: 10px;
    padding: 2px 3px;
  }
}
.other-info {
  margin-top: 6px;
  .hospital-brand {
    width: fit-content;
    font-weight: 400;
    font-size: 10px;
    color: #bb5a00;
    background: linear-gradient(180deg, #ffbb90 0%, #ffe2e1 99%);
    border-radius: 2px;
    padding: 2px 6px;
  }
  .hospital-top {
    display: flex;
    align-items: center;
    width: fit-content;
    height: 15px;
    margin-top: 5px;
    background: linear-gradient(180deg, #ffbb90 0%, #ffe2e1 99%);
    border-radius: 2px;
    overflow: hidden;
    .icon-trophy {
      width: 15px;
      height: 100%;
      background: #FFAD56;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAZ5JREFUOE+VlE0ow3EYxz9blrcpzLIolNe8RPJ2sKIclpRysJODUkpykHIgVxe5kHJxVDtYOXtJTaKt5WCrRXkP/dltqAn9/v+/Yf/N/p7j73meT9/n6fv8DB8bgx8kClNWwmf5MfqsyRk0IGs9tIxBpiU56OUJfCsgncRqFJDRBLZmSMuAOuffkK9WAQu44O0V7rwooKYRKG6HlzDkliVXEp+RAmC2wZVHBdnn4HofLnZhwKUf5HZCRS8U1Kqgzlm4PYTz7f+Dqvohv1IFNY8qKvyr/we1TUDkUQVZqkGo2poEx7L+0banoHse9mZUkGgVCy9sgmyrflBEgmsPBF0/QAYjiBFLu/SDQpsQWJfrtYZsGYcSe2rYlQd832vQgrKs0LOgmDNZRCOwMw3PUpyz4xsKaqF1PLHDhaOPFiF89qtLq+grLY62uEM2mzzq5R5IQbg5gPeojqOVN2eEvHIwF0F6DjQMwfEaiJEiDxA+1QESB2yfBUtN8h3d++Fw8Zcy7WiVfYqCVOFdUu5TDS2ocRjKHakwyhcScsfqPgHRcZ633LH6DAAAAABJRU5ErkJggg==");
      background-position: center center;
      background-size: 10px 10px;
      background-repeat: no-repeat;
    }
    &-text {
      font-weight: 400;
      font-size: 8px;
      color: #FF5850;
      margin-left: 11px;
    }
    .icon-right {
      display: flex;
      align-items: center;
      width: 6px;
      height: 7px;
      margin-top: -2px;
      margin-left: 2px;
      margin-right: 14px;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAAAXNSR0IArs4c6QAAAINJREFUGFdFjUEKgmAYRN/Hr0Eo2Clq0UpCrKBF0FmignZGd+gaeQDvUxv5paRLTEiksxp4bxjT/SbqFtIpJDH/mIq9aD7gHKQzyOYQBpiKg2ja3iQawzbHdDkK/x5A1wLXgZPwrwHEEew2mK5nUfvfx3IBqwxGIaaqFI8nrHOYJP3yC6UmJSHVINrpAAAAAElFTkSuQmCC");
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  .doctor-good {
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    color: #666666;
    margin-top: 2px;
  }
}
</style>